import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getOptionsFromWindow, isCrawler, promiseTimeout } from "../../../utils";
import { getUserDecision } from "../..";
import { locationRestConsentDynamicPredecisionGet } from "../../../wp-api";
import { commonRequest } from "@devowl-wp/utils";
/**
 * Dynamically allow to get a predecision with a extra request to our REST API.
 */

var preDecisionGatewayDynamicRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getOptionsFromWindow, restNamespace, restRoot, restQuery, _getOptionsFromWindow2, revisionHash, hasDynamicPreDecisions, decision, revision, _document$documentEle, clientWidth, clientHeight, _yield$promiseTimeout, predecision;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getOptionsFromWindow = getOptionsFromWindow(), restNamespace = _getOptionsFromWindow.restNamespace, restRoot = _getOptionsFromWindow.restRoot, restQuery = _getOptionsFromWindow.restQuery, _getOptionsFromWindow2 = _getOptionsFromWindow.others, revisionHash = _getOptionsFromWindow2.revisionHash, hasDynamicPreDecisions = _getOptionsFromWindow2.hasDynamicPreDecisions;

            if (!(isCrawler() || !hasDynamicPreDecisions)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            // Check if revision has changed, and probably access our dynamic predecision again
            decision = getUserDecision();

            if (!decision) {
              _context.next = 8;
              break;
            }

            revision = decision.revision;

            if (!(revisionHash === revision)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", "consent");

          case 8:
            _document$documentEle = document.documentElement, clientWidth = _document$documentEle.clientWidth, clientHeight = _document$documentEle.clientHeight;
            _context.prev = 9;
            _context.next = 12;
            return promiseTimeout(commonRequest({
              location: locationRestConsentDynamicPredecisionGet,
              options: {
                restNamespace: restNamespace,
                restRoot: restRoot,
                restQuery: restQuery
              },
              request: {
                viewPortWidth: clientWidth,
                viewPortHeight: clientHeight
              },
              params: {
                _wp_http_referer: window.location.href
              }
            }), 10000);

          case 12:
            _yield$promiseTimeout = _context.sent;
            predecision = _yield$promiseTimeout.predecision;
            return _context.abrupt("return", predecision);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", false);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 17]]);
  }));

  return function preDecisionGatewayDynamicRequest() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayDynamicRequest };